import { SET_LOCK_DATA, LOCK_DATA_REQUEST, LOCK_DATA_REQUEST_FAILURE } from "../types";

const initialState = {
  lockData: {},
  loading: false,
  error: null,
};

const lockDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOCK_DATA_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case SET_LOCK_DATA: {
      return {
        ...state,
        lockData: { ...action.payload },
        loading: false,
        error: null
      }
    }
    case LOCK_DATA_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default lockDataReducer;